import { Content as AntdContent } from './style.module';

export const Content = ({ type, children }: { type: string, children: React.ReactNode }) => {
    return (
        <AntdContent className={type}>
            {children}
        </AntdContent>
    );
}
